var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrymyaiSs3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106.07,
    height: 39.646,
    viewBox: "0 0 106.07 39.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18450",
    x: 0,
    y: 0,
    width: 106.07,
    height: 39.646,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17323",
    x: 0,
    y: 0,
    width: 106.07,
    height: 39.646,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50380",
    "data-name": "Path 50380",
    d: "M7112.617,47.9h0l6.821,6.238,2.489-2.418.4-1.8-.9-2.435-2.663-1.725-.284-4.089h-2.891l-3.814,2.363",
    transform: "translate(-7111.768 -41.67)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11707",
    "data-name": "Path 11707",
    d: "M706.287,1723.221l.891-.021.32,1.076-1.5.02Z",
    transform: "translate(-706 -1723.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11710",
    "data-name": "Path 11710",
    d: "M598.579,338.276c.075-.161.8-.152.87,0,.246.529,1.042,3.149,1.056,3.277a6.235,6.235,0,0,1-.2,2.615c-.41,2.084-.856,4.423-.856,4.423l-.879-.015s-.439-2.325-.85-4.408a6.25,6.25,0,0,1-.2-2.615C597.536,341.425,598.332,338.805,598.579,338.276Z",
    transform: "translate(-597.468 -338.159)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11714",
    "data-name": "Path 11714",
    d: "M635.4,1159.459l.768,3.994.976,0,.79-4.05Z",
    transform: "translate(-635.4 -1159.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_814",
    "data-name": "Ellipse 814",
    cx: 0.363,
    cy: 0.363,
    rx: 0.363,
    ry: 0.363
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11723",
    "data-name": "Path 11723",
    d: "M981.7,761.868l1.518,1.054a2.039,2.039,0,0,0,1.038,2.732l.107-.84.093.008-.164,1.413a2.6,2.6,0,0,0,.969-3.4.754.754,0,0,0-.08-.135A2.55,2.55,0,0,0,981.7,761.868Z",
    transform: "translate(-981.7 -761.498)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11729",
    "data-name": "Path 11729",
    d: "M4.5,3.243,2.718,2.761A2.038,2.038,0,0,0,.822.536L1,1.362l-.09.023L.592,0A2.6,2.6,0,0,0,.822,3.532a.647.647,0,0,0,.121.1A2.55,2.55,0,0,0,4.5,3.243Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11733",
    "data-name": "Path 11733",
    d: "M946.1,769.3l.088.529.051.307.05.042-.023.114-1.065-.63,0-.291Z",
    transform: "translate(-945.2 -769.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11736",
    "data-name": "Path 11736",
    d: "M.321,0,.153.509l-.1.3L0,.839,0,.955,1.153.5,1.2.21Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_18450)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18450-2",
    "data-name": "Rectangle 18450",
    width: 88.07,
    height: 21.646,
    rx: 5,
    fill: "#fff"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28621",
    "data-name": "Group 28621",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_17323)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17323-2",
    "data-name": "Rectangle 17323",
    width: 88.07,
    height: 21.646,
    rx: 5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17324",
    "data-name": "Rectangle 17324",
    width: 31.011,
    height: 4.059,
    rx: 2,
    transform: "translate(4.059 8.794)",
    fill: "rgba(6,35,61,0.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17325",
    "data-name": "Rectangle 17325",
    width: 7.441,
    height: 4.059,
    rx: 2,
    transform: "translate(54.01 8.794)",
    fill: "rgba(6,35,61,0.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17326",
    "data-name": "Rectangle 17326",
    width: 7.441,
    height: 4.059,
    rx: 2,
    transform: "translate(66.862 8.794)",
    fill: "rgba(6,35,61,0.32)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "new",
    transform: "translate(37.379 5.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50359",
    "data-name": "Path 50359",
    d: "M11.025,5c-.18-.133-.407-.3-.434-.407a1.361,1.361,0,0,1,.175-.6c.159-.364.322-.741.14-1.055s-.6-.364-.994-.407a1.354,1.354,0,0,1-.594-.142,1.353,1.353,0,0,1-.141-.6c-.045-.4-.091-.81-.407-.994S8.077.782,7.713.943a1.365,1.365,0,0,1-.6.175c-.11-.029-.275-.254-.407-.434C6.479.373,6.22.02,5.844.02S5.21.373,4.98.684c-.133.18-.3.407-.407.435a1.394,1.394,0,0,1-.6-.175C3.611.782,3.234.622,2.922.8s-.365.6-.41,1a1.36,1.36,0,0,1-.141.594,1.358,1.358,0,0,1-.592.139c-.4.045-.811.091-.994.407S.762,3.631.923,4a1.36,1.36,0,0,1,.175.6C1.068,4.7.844,4.869.664,5,.353,5.229,0,5.489,0,5.865s.353.635.664.864c.18.133.407.3.434.407a1.361,1.361,0,0,1-.175.6C.765,8.1.6,8.472.783,8.786s.6.364.994.407a1.354,1.354,0,0,1,.594.142,1.353,1.353,0,0,1,.141.6c.045.4.091.81.407.994s.69.018,1.055-.14a1.4,1.4,0,0,1,.6-.173c.11.029.275.254.407.434.229.311.489.664.864.664s.635-.353.864-.664c.133-.18.3-.407.407-.435a1.372,1.372,0,0,1,.6.175c.364.159.741.321,1.054.141s.365-.6.41-.994a1.36,1.36,0,0,1,.141-.594A1.358,1.358,0,0,1,9.91,9.2c.4-.045.811-.091.994-.407s.018-.69-.14-1.055a1.36,1.36,0,0,1-.173-.6c.029-.11.254-.275.434-.407.311-.229.664-.489.664-.864S11.336,5.229,11.025,5Z",
    transform: "translate(0 -0.02)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50360",
    "data-name": "Path 50360",
    d: "M108.313,194.374a.235.235,0,0,1-.188-.094l-.988-1.318v1.177a.235.235,0,1,1-.471,0v-1.882a.235.235,0,0,1,.424-.141l.988,1.318v-1.177a.235.235,0,0,1,.471,0v1.882a.235.235,0,0,1-.161.223A.232.232,0,0,1,108.313,194.374Z",
    transform: "translate(-103.912 -187.353)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M.235,2.353A.235.235,0,0,1,0,2.118V.235A.235.235,0,0,1,.235,0h.942a.235.235,0,0,1,0,.471H.471V.942h.706a.235.235,0,0,1,0,.471H.471v.47h.706a.235.235,0,0,1,0,.47Z",
    transform: "translate(5.106 4.668)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50363",
    "data-name": "Path 50363",
    d: "M300.315,194.365a.235.235,0,0,1-.223-.161l-.247-.742-.247.742a.225.225,0,0,1-.233.16.235.235,0,0,1-.219-.178l-.471-1.882a.235.235,0,0,1,.457-.114l.274,1.1.215-.645a.245.245,0,0,1,.447,0l.215.645.274-1.1a.235.235,0,0,1,.457.114l-.471,1.882a.235.235,0,0,1-.219.178Z",
    transform: "translate(-291.678 -187.344)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25257",
    "data-name": "Group 25257",
    transform: "translate(71.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50379",
    "data-name": "Path 50379",
    d: "M7098.812,41l16.668,15.309V46.072c0-2.117.275-5.072-4.721-5.072Z",
    transform: "translate(-7098.812 -41)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25374",
    "data-name": "Mask Group 25374",
    transform: "translate(6.053 0.064)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(-0.058 0.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27253",
    "data-name": "Group 27253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11685",
    "data-name": "Path 11685",
    d: "M526.237,1187.752a.056.056,0,0,0-.055-.052h-1.054a.028.028,0,0,0-.028.028h0a.028.028,0,0,0,.028.028h1.108S526.237,1187.755,526.237,1187.752Z",
    transform: "translate(-522.074 -1178.781)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11686",
    "data-name": "Path 11686",
    d: "M374.533,1050.017l-.991-.991h0l-.018.018a.027.027,0,0,0,0,.039h0l.954.954a.027.027,0,0,0,.039,0h0Z",
    transform: "translate(-371.624 -1041.147)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11687",
    "data-name": "Path 11687",
    d: "M499.02,1173.9a.12.12,0,1,1-.12.12A.12.12,0,0,1,499.02,1173.9Zm0,.044a.077.077,0,1,1-.077.076h0A.077.077,0,0,1,499.02,1173.944Z",
    transform: "translate(-496.07 -1165.084)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11688",
    "data-name": "Path 11688",
    d: "M930.4,1187.728a.028.028,0,0,1,.028-.028h1.105a0,0,0,0,1,0,0h0a.056.056,0,0,1-.056.052h-1.054a.029.029,0,0,1-.028-.028Z",
    transform: "translate(-924.33 -1178.781)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11689",
    "data-name": "Path 11689",
    d: "M1099.02,1051.413a.028.028,0,0,1,0-.039h0l.954-.954a.027.027,0,0,1,.039,0h0l.02.02-.991.991h0Z",
    transform: "translate(-1091.676 -1042.524)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11690",
    "data-name": "Path 11690",
    d: "M1076.12,1173.9a.12.12,0,1,0,.12.12A.12.12,0,0,0,1076.12,1173.9Zm0,.044a.077.077,0,1,0,.077.076A.077.077,0,0,0,1076.12,1173.944Z",
    transform: "translate(-1068.837 -1165.084)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11691",
    "data-name": "Path 11691",
    d: "M578.637,1298.2a.056.056,0,0,1-.056.056h-1.054a.028.028,0,0,1-.028-.028h0a.028.028,0,0,1,.028-.028h1.054a.056.056,0,0,1,.056.056h0Z",
    transform: "translate(-574.08 -1288.451)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11692",
    "data-name": "Path 11692",
    d: "M468.259,1308.577l-.678.678a0,0,0,0,1,0,0h0l-.018-.018a.028.028,0,0,1,0-.039h0l.641-.64a.028.028,0,0,1,.039,0h0Z",
    transform: "translate(-464.956 -1298.723)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11693",
    "data-name": "Path 11693",
    d: "M551.52,1287.54a.12.12,0,1,0-.12-.12A.121.121,0,0,0,551.52,1287.54Zm0-.044a.077.077,0,1,0-.077-.077h0A.075.075,0,0,0,551.52,1287.5Z",
    transform: "translate(-548.176 -1277.632)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11694",
    "data-name": "Path 11694",
    d: "M878,1298.128a.028.028,0,0,0,.028.028h1.106a0,0,0,0,0,0,0h0a.056.056,0,0,0-.056-.052h-1.054a.029.029,0,0,0-.029.028Z",
    transform: "translate(-872.324 -1288.351)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11695",
    "data-name": "Path 11695",
    d: "M1046.658,1307.069a.028.028,0,0,0,0,.039h0l.641.641a.028.028,0,0,0,.039,0h0l.02-.02-.678-.678a0,0,0,0,0,0,0h0Z",
    transform: "translate(-1039.707 -1297.234)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11696",
    "data-name": "Path 11696",
    d: "M1023.72,1287.54a.12.12,0,1,1,.12-.12A.12.12,0,0,1,1023.72,1287.54Zm0-.044a.077.077,0,1,1,.077-.077h0A.076.076,0,0,1,1023.72,1287.5Z",
    transform: "translate(-1016.83 -1277.632)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11697",
    "data-name": "Path 11697",
    d: "M646.644,1326.24l-.8.8a0,0,0,0,1,0,0h0l-.018-.018a.027.027,0,0,1,0-.039h0l.764-.765a.028.028,0,0,1,.039,0h0Z",
    transform: "translate(-641.879 -1316.253)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11698",
    "data-name": "Path 11698",
    d: "M635.856,1452.7v.734h-.028a.028.028,0,0,1-.028-.028v-.677a.028.028,0,0,1,.028-.028Z",
    transform: "translate(-631.943 -1441.791)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11699",
    "data-name": "Path 11699",
    d: "M624.918,1426.718a.121.121,0,1,0-.171,0A.121.121,0,0,0,624.918,1426.718Zm-.031-.031a.076.076,0,1,0-.108,0,.076.076,0,0,0,.108,0Z",
    transform: "translate(-620.938 -1415.8)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11700",
    "data-name": "Path 11700",
    d: "M851.92,1324.868a.028.028,0,0,0,0,.039h0l.764.764a.027.027,0,0,0,.039,0h0l.02-.02-.8-.8a0,0,0,0,0,0,0h0Z",
    transform: "translate(-846.432 -1314.901)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11701",
    "data-name": "Path 11701",
    d: "M963.828,1452.6a.028.028,0,0,0-.028.028v.677a.028.028,0,0,0,.028.028h.028v-.733Z",
    transform: "translate(-957.479 -1441.691)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11702",
    "data-name": "Path 11702",
    d: "M950.148,1426.718a.12.12,0,1,1,.17,0A.12.12,0,0,1,950.148,1426.718Zm.031-.031a.076.076,0,1,1,.108,0,.076.076,0,0,1-.108,0Z",
    transform: "translate(-943.894 -1415.8)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11703",
    "data-name": "Path 11703",
    d: "M706.287,1723.221l.891-.021.319,1.076-1.5.02Z",
    transform: "translate(-701.615 -1710.259)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3884",
    "data-name": "Group 3884",
    transform: "translate(4.385 12.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3883",
    "data-name": "Group 3883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3882",
    "data-name": "Group 3882",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11704",
    "data-name": "Path 11704",
    d: "M716.421,1695.4a.126.126,0,1,1-.251,0h0a.13.13,0,0,1-.125.132.123.123,0,0,1-.088-.038.169.169,0,0,1-.186.077h0a.182.182,0,0,1-.126-.219c.057-.243.16-.681.218-.923a.172.172,0,0,1,.209-.132h0a.143.143,0,0,1,.114.188l0,.014h.207l0-.014c-.023-.1.045-.164.138-.188h0a.172.172,0,0,1,.209.132c.057.243.16.68.218.923a.182.182,0,0,1-.126.219h0a.169.169,0,0,1-.187-.079.124.124,0,0,1-.089.039.129.129,0,0,1-.125-.132Z",
    transform: "translate(-715.567 -1694.506)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11705",
    "data-name": "Path 11705",
    d: "M809.8,1725.145l.151.008,0-.267.075.262.128-.059-.212-.79H809.8Z",
    transform: "translate(-809.02 -1724.292)",
    fill: "#fcc4c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11706",
    "data-name": "Path 11706",
    d: "M754.755,1725.145l-.151.008,0-.267-.075.262-.128-.059.213-.79h.141Z",
    transform: "translate(-754.036 -1724.292)",
    fill: "#fcc4c8",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11708",
    "data-name": "Path 11708",
    d: "M598.579,338.276c.075-.161.8-.152.87,0,.246.529,1.042,3.149,1.056,3.277a6.235,6.235,0,0,1-.2,2.615c-.41,2.084-.856,4.423-.856,4.423l-.879-.015s-.439-2.325-.85-4.408a6.25,6.25,0,0,1-.2-2.615C597.536,341.425,598.332,338.805,598.579,338.276Z",
    transform: "translate(-593.899 -335.619)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    transform: "translate(3.57 2.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3885",
    "data-name": "Group 3885",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11709",
    "data-name": "Path 11709",
    d: "M608.4,1004.1l2.925.017-.695,5.392-1.5.022Z",
    transform: "translate(-608.318 -999.099)",
    fill: "#f34a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2847",
    "data-name": "Rectangle 2847",
    width: 3.277,
    height: 0.062,
    transform: "translate(-0.185 5.001)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2848",
    "data-name": "Rectangle 2848",
    width: 3.277,
    height: 0.062,
    transform: "translate(-0.185 6.631)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2849",
    "data-name": "Rectangle 2849",
    width: 3.277,
    height: 0.062,
    transform: "translate(-0.185 7.92)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2850",
    "data-name": "Rectangle 2850",
    width: 3.277,
    height: 0.062,
    transform: "translate(-0.185 9.209)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_810",
    "data-name": "Ellipse 810",
    cx: 0.392,
    cy: 0.392,
    rx: 0.392,
    ry: 0.392,
    transform: "translate(0.654 0.393)",
    fill: "rgba(249,123,132,0.55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_811",
    "data-name": "Ellipse 811",
    cx: 0.392,
    cy: 0.392,
    rx: 0.392,
    ry: 0.392,
    transform: "translate(1.723 0.393)",
    fill: "rgba(249,123,132,0.55)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11711",
    "data-name": "Path 11711",
    d: "M635.4,1159.459l.768,3.994.976,0,.79-4.05Z",
    transform: "translate(-631.545 -1150.693)",
    fill: "#3f5d8d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890",
    transform: "translate(3.855 8.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11712",
    "data-name": "Path 11712",
    d: "M630.053,1162.709l.013.437-.366.312.22,2.172-.161-2.118.379-.359-.027-.453Z",
    transform: "translate(-629.743 -1162.675)",
    fill: "rgba(0,0,0,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11713",
    "data-name": "Path 11713",
    d: "M918.785,1162.709l-.014.437.366.312-.22,2.172.161-2.118-.379-.359.027-.453Z",
    transform: "translate(-916.572 -1162.675)",
    fill: "rgba(0,0,0,0.2)",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11715",
    "data-name": "Path 11715",
    d: "M725.9,1652.937l1.2-.038.013.359-1.2.039Z",
    transform: "translate(-721.366 -1640.486)",
    fill: "#587cb4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_812",
    "data-name": "Ellipse 812",
    cx: 0.363,
    cy: 0.363,
    rx: 0.363,
    ry: 0.363,
    transform: "translate(4.25 2.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3893",
    "data-name": "Group 3893",
    transform: "translate(4.25 2.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3892",
    "data-name": "Group 3892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3891",
    "data-name": "Group 3891",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_813",
    "data-name": "Ellipse 813",
    cx: 0.363,
    cy: 0.356,
    rx: 0.363,
    ry: 0.356,
    transform: "translate(0.003 -0.175)",
    fill: "#002234"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_815",
    "data-name": "Ellipse 815",
    cx: 0.363,
    cy: 0.363,
    rx: 0.363,
    ry: 0.363,
    transform: "translate(5.319 2.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3896",
    "data-name": "Group 3896",
    transform: "translate(5.319 2.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3895",
    "data-name": "Group 3895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_816",
    "data-name": "Ellipse 816",
    cx: 0.363,
    cy: 0.356,
    rx: 0.363,
    ry: 0.356,
    transform: "translate(0.003 -0.175)",
    fill: "#002234"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11716",
    "data-name": "Path 11716",
    d: "M823.765,33.161l-.026,0a.026.026,0,0,0-.03.022l-.352,2.3a.026.026,0,0,0,.022.03l.023,0s0,0,0,0h0Z",
    transform: "translate(-818.091 -32.908)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_818",
    "data-name": "Ellipse 818",
    cx: 0.177,
    cy: 0.177,
    rx: 0.177,
    ry: 0.177,
    transform: "translate(5.477)",
    fill: "#f34a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11717",
    "data-name": "Path 11717",
    d: "M729.757,33.534a.026.026,0,0,1,.022-.03l.022,0s0,0,0,0h0l.373,2.348-.026,0a.026.026,0,0,1-.03-.022Z",
    transform: "translate(-725.194 -33.248)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_819",
    "data-name": "Ellipse 819",
    cx: 0.177,
    cy: 0.177,
    rx: 0.177,
    ry: 0.177,
    transform: "translate(4.402 0.006)",
    fill: "#f34a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11718",
    "data-name": "Path 11718",
    d: "M981.7,761.868l1.518,1.054a2.039,2.039,0,0,0,1.038,2.732l.107-.84.093.008-.164,1.413a2.6,2.6,0,0,0,.969-3.4.754.754,0,0,0-.08-.135A2.55,2.55,0,0,0,981.7,761.868Z",
    transform: "translate(-975.245 -755.779)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899",
    transform: "translate(6.455 5.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3897",
    "data-name": "Group 3897",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11719",
    "data-name": "Path 11719",
    d: "M954.932,658.117l2.269-.22-2.709-2-1.292.9v.557Z",
    transform: "translate(-953.414 -656.693)",
    fill: "#f34a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11720",
    "data-name": "Path 11720",
    d: "M1030,761.243l.131-.743",
    transform: "translate(-1029.637 -760.508)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11721",
    "data-name": "Path 11721",
    d: "M1100.4,765.111l1.344-1.111",
    transform: "translate(-1099.509 -763.981)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11722",
    "data-name": "Path 11722",
    d: "M1169,922.345l2.2-.245",
    transform: "translate(-1167.593 -920.894)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11724",
    "data-name": "Path 11724",
    d: "M4.5,3.243,2.718,2.761A2.038,2.038,0,0,0,.822.536L1,1.362l-.09.023L.592,0A2.6,2.6,0,0,0,.822,3.532a.647.647,0,0,0,.121.1A2.55,2.55,0,0,0,4.5,3.243Z",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 2.902, 0.354)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 2.902, 0.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900",
    transform: "translate(0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11725",
    "data-name": "Path 11725",
    d: "M2.062,0,0,.969l3.223.97L4.136.659,3.949.134Z",
    transform: "translate(0.655 2.761)",
    fill: "#f34a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11726",
    "data-name": "Path 11726",
    d: "M0,0,.126.745",
    transform: "translate(4.037 3.02)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11727",
    "data-name": "Path 11727",
    d: "M.893,0,0,1.5",
    transform: "translate(2.514 2.827)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11728",
    "data-name": "Path 11728",
    d: "M1.987,0,0,.969",
    transform: "translate(0.825 2.697)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11730",
    "data-name": "Path 11730",
    d: "M596.011,684.249a2.192,2.192,0,0,1-.373-.052,1.865,1.865,0,0,0-.852,0c-.231.1-.117-.418-.146-.544s-.2-1.46-.191-1.723a4.472,4.472,0,0,1,.284-1.43,1.6,1.6,0,0,0,2.558,0,4.492,4.492,0,0,1,.284,1.43c.01.263-.162,1.6-.191,1.723s.085.643-.146.544a1.865,1.865,0,0,0-.852,0A2.1,2.1,0,0,1,596.011,684.249Z",
    transform: "translate(-590.9 -675.39)",
    fill: "#d2e7e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11731",
    "data-name": "Path 11731",
    d: "M946,769.3l.088.529.051.307.05.043-.023.114-1.065-.63,0-.291Z",
    transform: "translate(-938.92 -763.523)",
    fill: "#d2e7e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905",
    transform: "translate(6.181 5.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11732",
    "data-name": "Path 11732",
    d: "M1083.552,815.7l-.152.485.034.178Z",
    transform: "translate(-1082.362 -815.351)",
    fill: "#001b2a",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11734",
    "data-name": "Path 11734",
    d: "M.321,0,.153.509l-.1.3L0,.839,0,.955,1.153.5,1.2.21Z",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 3.382, 5.105)",
    fill: "#d2e7e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908",
    transform: "translate(2.718 5.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 0.664, 0)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11735",
    "data-name": "Path 11735",
    d: "M0,0,.075.5.014.674Z",
    transform: "translate(-0.016 0.3)",
    fill: "#001b2a",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11737",
    "data-name": "Path 11737",
    d: "M633.291,681.382c.547-.051,1.281-.882,1.281-.882l.019.064a2.449,2.449,0,0,1-1.3.885,2.42,2.42,0,0,1-1.287-.885l.019-.064s.728.834,1.269.882Z",
    transform: "translate(-628.171 -675.39)",
    fill: "#009081",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2851",
    "data-name": "Rectangle 2851",
    width: 0.044,
    height: 0.171,
    transform: "translate(5.097 5.99)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11738",
    "data-name": "Path 11738",
    d: "M700.668,812.111a.01.01,0,0,0-.01-.01H699.11a.015.015,0,0,0-.008,0,.012.012,0,0,0,0,.008v.6a.01.01,0,0,0,.01.01h1.547a.016.016,0,0,0,.008,0,.013.013,0,0,0,0-.007Z",
    transform: "translate(-694.767 -806.001)",
    fill: "#009081",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11739",
    "data-name": "Path 11739",
    d: "M709.04,820.71a.009.009,0,0,0,0-.008.009.009,0,0,0-.007,0H707.61a.009.009,0,0,0-.008,0,.009.009,0,0,0,0,.008v.466a.008.008,0,0,0,0,.007.01.01,0,0,0,.008,0h1.419a.009.009,0,0,0,.007,0,.01.01,0,0,0,0-.007Z",
    transform: "translate(-703.203 -814.537)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11740",
    "data-name": "Path 11740",
    d: "M722.522,840.712l.023.006a.079.079,0,0,1-.027.045.087.087,0,0,1-.094,0,.073.073,0,0,1-.027-.035.122.122,0,0,1-.01-.049.1.1,0,0,1,.011-.049.077.077,0,0,1,.03-.032.086.086,0,0,1,.044-.011.068.068,0,0,1,.07.052l-.023.005a.054.054,0,0,0-.018-.029.045.045,0,0,0-.029-.009.059.059,0,0,0-.034.01.055.055,0,0,0-.02.027.106.106,0,0,0-.006.034.12.12,0,0,0,.007.041.051.051,0,0,0,.02.025.047.047,0,0,0,.03.008.052.052,0,0,0,.034-.012A.044.044,0,0,0,722.522,840.712Z",
    transform: "translate(-717.88 -834.278)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11741",
    "data-name": "Path 11741",
    d: "M747.2,841.281V841.1h.023v.16h.088v.021Z",
    transform: "translate(-742.506 -834.783)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11742",
    "data-name": "Path 11742",
    d: "M763.2,841.281l.068-.181h.026l.073.181h-.026l-.021-.055h-.074l-.02.055Zm.051-.074h.06l-.018-.05c-.006-.015-.01-.028-.013-.037a.173.173,0,0,1-.01.034Z",
    transform: "translate(-758.386 -834.783)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11743",
    "data-name": "Path 11743",
    d: "M784.447,841.281l-.047-.181h.024l.027.119c0,.013.005.025.007.038,0-.02.008-.031.008-.034l.034-.122h.029l.026.092a.485.485,0,0,1,.013.065c0-.011.005-.025.009-.04l.028-.116h.024l-.049.181h-.022l-.037-.138c0-.012-.005-.019-.005-.021l-.005.021-.038.138Z",
    transform: "translate(-779.426 -834.783)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11744",
    "data-name": "Path 11744",
    d: "M816.8,840.826l.022,0a.049.049,0,0,0,.008.023.037.037,0,0,0,.018.014.067.067,0,0,0,.027.005.076.076,0,0,0,.023,0,.037.037,0,0,0,.016-.011.027.027,0,0,0,.005-.016.028.028,0,0,0,0-.015.031.031,0,0,0-.017-.01l-.031-.009a.139.139,0,0,1-.035-.011.045.045,0,0,1-.019-.017.046.046,0,0,1-.006-.023.051.051,0,0,1,.008-.026.048.048,0,0,1,.022-.018.082.082,0,0,1,.032-.006.1.1,0,0,1,.035.007.051.051,0,0,1,.023.019.061.061,0,0,1,.009.028h-.022a.036.036,0,0,0-.012-.026.046.046,0,0,0-.031-.009.049.049,0,0,0-.031.008.025.025,0,0,0-.01.02.02.02,0,0,0,.007.016.09.09,0,0,0,.035.013.254.254,0,0,1,.04.012.05.05,0,0,1,.023.019.043.043,0,0,1,.008.026.048.048,0,0,1-.008.027.049.049,0,0,1-.023.02.067.067,0,0,1-.035.007.105.105,0,0,1-.04-.007.056.056,0,0,1-.026-.022A.053.053,0,0,1,816.8,840.826Z",
    transform: "translate(-811.583 -834.387)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11745",
    "data-name": "Path 11745",
    d: "M838.9,840.79a.1.1,0,0,1,.024-.07.079.079,0,0,1,.061-.026.083.083,0,0,1,.044.012.072.072,0,0,1,.03.034.115.115,0,0,1,0,.1.072.072,0,0,1-.031.033.086.086,0,0,1-.043.011.081.081,0,0,1-.045-.013.082.082,0,0,1-.03-.034A.113.113,0,0,1,838.9,840.79Zm.025,0a.077.077,0,0,0,.017.052.06.06,0,0,0,.084,0l0,0a.079.079,0,0,0,.017-.054.1.1,0,0,0-.007-.039.056.056,0,0,0-.022-.025.059.059,0,0,0-.032-.009.061.061,0,0,0-.043.017.084.084,0,0,0-.018.059Z",
    transform: "translate(-833.517 -834.381)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11746",
    "data-name": "Path 11746",
    d: "M865.6,841.281V841.1h.024l.093.143V841.1h.023v.181h-.024l-.093-.143v.143Z",
    transform: "translate(-860.016 -834.783)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11747",
    "data-name": "Path 11747",
    d: "M767.955,568a.328.328,0,0,1-.306.306.324.324,0,0,1-.3-.281.02.02,0,0,1,.017-.023h.017a.3.3,0,0,0,.268.258.3.3,0,0,0,.265-.244.018.018,0,0,1,.017-.013Z",
    transform: "translate(-762.501 -563.734)",
    fill: "#002234",
    fillRule: "evenodd"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25375",
    "data-name": "Mask Group 25375",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18449",
    "data-name": "Rectangle 18449",
    d: "M3.059,0h0a0,0,0,0,1,0,0V21.646a0,0,0,0,1,0,0h0A3.059,3.059,0,0,1,0,18.587V3.059A3.059,3.059,0,0,1,3.059,0Z",
    transform: "translate(-1)",
    fill: "#a2b0b7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrymyaiSs3);
export default __webpack_public_path__ + "static/media/trymyai-ss-3.8f7649ecbfa33aa32949129b3e9e933a.svg";
export { ForwardRef as ReactComponent };